import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-622c56f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-mask"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "tables-wrapper" }
const _hoisted_5 = { class: "table-block" }
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = { class: "backtest-table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "col-tracking" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-period" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data-wide" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data-wide" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-tracking" }, "数据跟踪"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-period" }, "统计周期"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "多头盈亏比"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "平均持有周期"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "平均单笔盈利"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "平均单笔亏损")
  ])
], -1))
const _hoisted_10 = ["rowspan"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tracking-label" }, "量化模型收益分析", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "track-popover-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "track-popover-title" }, "量化模型收益分析说明"),
  /*#__PURE__*/_createElementVNode("p", { class: "track-popover-desc" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "track-popover-label" }, "多头盈亏比："),
    /*#__PURE__*/_createTextVNode("把所有进场信号到离场信号之间的区间涨跌幅为正的周期视为盈利，并以此计算盈亏比 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "track-popover-desc" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "track-popover-label" }, "平均持有周期："),
    /*#__PURE__*/_createTextVNode("进场信号 → 离场信号周期的平均持有天数的平均值 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "track-popover-desc" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "track-popover-label" }, "平均单笔盈利："),
    /*#__PURE__*/_createTextVNode("把所有进场信号到离场信号之间的区间涨跌幅为正的周期视为盈利，并以此计算平均值 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "track-popover-desc" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "track-popover-label" }, "平均单笔亏损："),
    /*#__PURE__*/_createTextVNode("把所有进场信号到离场信号之间的区间涨跌幅为负的周期视为亏损，并以此计算平均值 ")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "track-info-icon commonquestion" }, null, -1))
const _hoisted_14 = { class: "col-period cell-border-right" }
const _hoisted_15 = { class: "col-data" }
const _hoisted_16 = { class: "col-data" }
const _hoisted_17 = { class: "col-data" }
const _hoisted_18 = { class: "col-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quant-gold-backtest", _ctx.theme])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelReturnData, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'model-' + index
                }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        rowspan: _ctx.modelReturnData.length,
                        class: "col-tracking cell-border-right"
                      }, [
                        _hoisted_11,
                        _createVNode(_component_a_popover, {
                          placement: "bottomLeft",
                          overlayClassName: "quant-gold-track-info-popover",
                          getPopupContainer: _ctx.getPopupContainer
                        }, {
                          content: _withCtx(() => [
                            _hoisted_12
                          ]),
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["getPopupContainer"])
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.period), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatProfitLossRatio(item.totalProfitLossRatio)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatDays(item.avgHoldDays)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatPercent(item.sellAvgProfit)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatPercent(item.sellAvgLoss)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 2))
}